// extracted by mini-css-extract-plugin
module.exports = {"sideMenuHeadline":"styles_sideMenuHeadline__1PGij"};